import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAtom } from 'jotai/index';
import styles from './css/index.module.scss';
import Loading from '../../ui-kit/Loading';
import LocalStorageServices from '../../services/LocalStorageServices';
import { isAuthAtom, screenToNavigateWhenAuthAtom, tokenAtom } from '../../atoms/accountAtoms';
import sendRequest from '../../helpers/sendRequest';
import Api from '../../api';
import { closeModalAtom, openInfoModalAtom } from '../../atoms/modalAtoms';
import useTranslations from '../../hooks/useTranslations';
import sleep from '../../helpers/sleep';

function InterlayerPage() {
  const { t } = useTranslations();
  const navigate = useNavigate();
  const { pathname } = window.location;
  const [searchParams] = useSearchParams();
  const paramsToken = searchParams.get('token');
  const paramsAdminToken = searchParams.get('admin-token');
  const paramsCode = searchParams.get('code');

  const [isAuth] = useAtom(isAuthAtom);
  const [, setToken] = useAtom(tokenAtom);
  const [, closeModal] = useAtom(closeModalAtom);
  const [, openInfoModal] = useAtom(openInfoModalAtom);
  const [, setScreenToNavigateWhenAuth] = useAtom(screenToNavigateWhenAuthAtom);

  const generateNewPassword = async (code) => {
    const data = await sendRequest({
      request: Api.generateTokenForNewPassword,
      payload: { code },
      warnErrorText: 'while generating token for new password',
    });

    return data;
  };

  useEffect(() => {
    (async () => {
      if (pathname === '/fast-login' && paramsToken) {
        LocalStorageServices.removeToken();
        setScreenToNavigateWhenAuth('/personal?ask_to_change_password=true');
        const modifiedToken = paramsToken?.replaceAll('_', '|'); // instead of "|" now comes "_"
        LocalStorageServices.setToken(modifiedToken);
        setToken(modifiedToken);

        await sleep(100);
        setScreenToNavigateWhenAuth('');
      } else if (pathname === '/password-recovery' && paramsCode) {
        LocalStorageServices.removeToken();
        const data = await generateNewPassword(paramsCode);
        if (data?.status === 'ok') {
          openInfoModal({ text: data.message });
          const { token: tokemFromResponse } = data.data;
          setScreenToNavigateWhenAuth('/set-new-password');
          LocalStorageServices.setToken(tokemFromResponse);
          setToken(tokemFromResponse);

          await sleep(100);
          setScreenToNavigateWhenAuth('');
        } else {
          navigate('/login');
        }
      } else if (pathname?.startsWith('/admin-fast-login') && paramsAdminToken) {
        if (isAuth) {
          LocalStorageServices.removeToken();
          setToken('');
          window.location.reload();
        } else {
          const newPath = pathname.split('/admin-fast-login')[1];
          const modifiedToken = paramsAdminToken?.replaceAll('_', '|'); // instead of "|" now comes "_"
          LocalStorageServices.setToken(modifiedToken);
          setToken(modifiedToken);

          navigate(newPath + window.location.search);
        }
      } else {
        navigate('/');
      }
    })();
  }, []);

  return (
    <div className={styles.interlayerPageWrapper}>
      <Loading width={40} height={40} />
    </div>
  );
}

export default InterlayerPage;
